import "core-js/modules/es.array.push.js";
import CryptoJS from "crypto-js";
import global from "../global";
import axios from "axios";
export default {
  data() {
    return {
      phone: "",
      password: "",
      userInfo: {},
      rememberPassword: false,
      tipResolver: null,
      showTip: false,
      tipMessage: "",
      tipNeedInput: false,
      tipInputText: ""
    };
  },
  async mounted() {
    // 隐藏菜单栏
    document.getElementById("menu").style.display = "none";
    document.getElementById("showAfterLogin").style.display = "none";

    // 如果记住了用户名密码
    if (localStorage.getItem("phone")) {
      this.phone = localStorage.getItem("phone");
      let encryptedPassword = localStorage.getItem("encryptedPassword");

      // 记住密码，把加密的密码 解密出来
      this.password = CryptoJS.AES.decrypt(encryptedPassword, global.keyArray.join("")).toString(CryptoJS.enc.Utf8);
      this.rememberPassword = true;
    }
  },
  methods: {
    rememberPasswordChange() {},
    // 点击记住密码文字，也是点击记住密码复选框
    clickRememberPassword() {
      this.rememberPassword = !this.rememberPassword;
    },
    async login() {
      // 检查输入
      if (!this.phone || !this.password) {
        alert("请填写手机号和密码");
        return;
      }

      // loading界面
      const loading = this.$loading({
        lock: true,
        text: "处理中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        //密码加密
        const encryptedPassword = CryptoJS.AES.encrypt(this.password, global.keyArray.join("") // 将数组转换为字符串作为密钥
        ).toString();

        // console.log("phone:", this.phone);
        // console.log("encryptedPassword:", encryptedPassword);

        // md5
        let md5 = CryptoJS.MD5(this.password + this.phone).toString();
        // console.log("md5:", md5);

        //校验手机号和密码
        let params = {
          // pw: this.password,  // 明文
          phone: this.phone,
          password: encryptedPassword,
          md5: md5
        };
        let resp1 = await axios.post("https://backend.wonology.com/login/login", params);
        if (resp1.data.code == "0000") {
          this.userInfo = resp1.data.data;

          // 根据用户权限，决定菜单栏显示
          if (!this.userInfo.roles) {
            this.userInfo.roles = ["查看", "编辑"];
          } else {
            this.userInfo.roles = JSON.parse(this.userInfo.roles);
          }

          // 保存用户所属的机构
          sessionStorage.setItem("institution", this.userInfo.institution);
          // 保存用户信息
          sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));

          // 如果点击了 记住用户名密码
          if (this.rememberPassword) {
            localStorage.setItem("phone", this.phone);
            localStorage.setItem("encryptedPassword", encryptedPassword);
          } else {
            localStorage.removeItem("phone");
            localStorage.removeItem("encryptedPassword");
          }

          // 调用App.vue 的 updateVariable函数
          // <router-view>中加 @updateVariable="updateVariable"
          this.$emit("updateVariable");
          this.$router.push({
            path: "/campus"
          });
        }
        // 登录失败
        else {
          if (resp1.data.msg == "手机号不存在" || resp1.data.msg == "密码错误") {
            alert("手机号或密码错误");
          } else {
            alert("登录失败:" + resp1.data.msg);
          }
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    async register() {
      this.showTip = true;
      this.tipMessage = "注册功能暂无";
      // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
      // 后面通过 this.tipResolver(value) 返回值
      const tipConfirmed = await new Promise(resolve => {
        this.tipResolver = resolve;
      });
      if (tipConfirmed === "confirm") {
        // 用户选择确认，继续执行

        this.showTip = false;
        // 重置变量
        this.tipMessage = "";
        this.tipNeedInput = false;
      } else {
        // 用户选择取消，返回

        return;
      }

      // this.$router.push("/signup");
    },
    // 提示弹窗 取消
    closeTip() {
      this.showTip = false;
      // 重置变量
      this.tipMessage = "";
      this.tipNeedInput = false;
      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("cancel");
        this.tipResolver = null;
      }
    },
    confirmTip() {
      // this.showTip = false;
      // // 重置变量
      // this.tipMessage = "";
      // this.tipNeedInput = false;

      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("confirm");
        this.tipResolver = null;
      }
    }
  }
};